import { useEffect, useContext } from "react";
import useResizeListener from "../components/useResizeListener";
import TitleContext from "../context/TitleContext";

const useTitleSetter = title => {
  const width = useResizeListener();
  const { setTitle } = useContext(TitleContext);
  useEffect(() => {
    if (width < 992) {
      setTitle(title);
    }
    return () => {
      setTitle("");
    };
  }, [setTitle, title, width]);
};

export default useTitleSetter;
